import { AlertOctagramOutlineIcon } from './AlertOctagramOutlineIcon';

/**
 * author: Peter Noble
 * id 2AD21B3E-77C1-4027-9AE9-7655246D9DFF
 * name alert-octagram-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-octagram-outline.svg
 * tags
 * - Alert / Error 
 */
export const WarningOctagramOutlineIcon = AlertOctagramOutlineIcon;
export default WarningOctagramOutlineIcon